<template>
  <div class="c-hiscores">
  </div>
</template>

<script>
  import hiscores from '../services/hiscores';

  export default {
    name: 'Hiscores',
    props: {
      player: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        hiscores: {},
      };
    },
    created() {
      this.getHiscores();
    },
    methods: {
      async getHiscores() {
        this.hiscores = await hiscores.getPlayer(this.player);
      },
    },
  };
</script>

<style scoped>

</style>
